<template>
  <div class="home">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0 px-1">
        <b-col
          cols="12"
          class="px-0 text-right mt-2"
          style="font-size: 1rem"
          :class="{ 'mb-3': sideBarLeft, 'mb-1': !sideBarLeft }"
        >
          <span class="my-0" id="elecboard-update-time">更新時間:</span>
          <span class="my-0" for="elecboard-update-time">{{ nowtime }}</span>
        </b-col>
        <b-col cols="12" class="px-0 pt-2">
          <b-row
            class="mx-auto"
            :style="{
              width: sideBarLeft ? '100%' : '100%',
              'min-width': '89rem'
            }"
          >
            <b-col
              cols="12"
              class="pr-2 pl-2"
              style="background-color: #f2f2f2"
              ref="range"
            >
              <div style="width: 100%; height: calc(100vh - 120px)">
                <b-row class="mx-0 mt-0 py-2 d-flex justify-content-around">
                  <b-col
                    cols="12"
                    class="m-2"
                    style="background-color: #ffffff; min-width: 50.7rem"
                    :style="{
                      height: home_map.clientHeight + 'px',
                      'min-height': home_map.clientHeight + 'px'
                    }"
                  >
                    <div
                      style="
                        position: absolute;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: #ffffff;
                      "
                    >
                      <template v-if="sideBarSelect.processName == '全廠'">
                        <div
                          v-for="(item, key) in eboard_device_factory_one"
                          :key="key"
                          :id="item.device_name"
                          :style="{
                            top:
                              item.style.top * (home_map.clientHeight / 857) +
                              'px',
                            left:
                              item.style.left * (home_map.clientWidth / 1892) +
                              'px',
                            width:
                              item.style.width * (home_map.clientWidth / 1892) +
                              'px',
                            height:
                              item.style.height *
                                (home_map.clientHeight / 857) +
                              'px',
                            'background-color': item.color
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            text-align: center;
                          "
                          class="p-0"
                        ></div>
                        <div
                          v-for="(item, key) in eboard_device_factory_two"
                          :key="key"
                          :id="item.device_name"
                          :style="{
                            top:
                              item.style.top * (home_map.clientHeight / 857) +
                              'px',
                            left:
                              item.style.left * (home_map.clientWidth / 1892) +
                              'px',
                            width:
                              item.style.width * (home_map.clientWidth / 1892) +
                              'px',
                            height:
                              item.style.height *
                                (home_map.clientHeight / 857) +
                              'px',
                            'background-color': item.color
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            text-align: center;
                          "
                          class="p-0"
                        ></div>
                        <div
                          v-for="(item, key) in eboard_package"
                          :key="key"
                          :id="item.device_name"
                          :style="{
                            top:
                              item.style.top * (home_map.clientHeight / 857) +
                              'px',
                            left:
                              item.style.left * (home_map.clientWidth / 1892) +
                              'px',
                            width:
                              item.style.width * (home_map.clientWidth / 1892) +
                              'px',
                            height:
                              item.style.height *
                                (home_map.clientHeight / 857) +
                              'px',
                            'background-color': item.color,
                            'line-height':
                              item.style.height *
                                (home_map.clientHeight / 857) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            text-align: center;
                          "
                          class="px-0 py-0"
                        ></div>
                        <div
                          v-for="(item, key) in eboard_container"
                          :key="key"
                          :id="item.device_name"
                          :style="{
                            top:
                              item.style.top * (home_map.clientHeight / 857) +
                              'px',
                            left:
                              item.style.left * (home_map.clientWidth / 1892) +
                              'px',
                            width:
                              (item.style.width *
                                (home_map.clientWidth / 1892) *
                                (item.status == 'S'
                                  ? 100
                                  : item.load_status.load_percent)) /
                                100 +
                              'px',
                            height:
                              item.style.height *
                                (home_map.clientHeight / 857) +
                              'px',
                            'background-color': item.color
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            border-radius: 2px;
                            text-align: left;
                            padding-left: 5px;
                            overflow: visible;
                          "
                        >
                          <div
                            :style="{
                              width:
                                item.style.width *
                                  (home_map.clientWidth / 1892) +
                                'px',
                              'line-height':
                                item.style.height *
                                  (home_map.clientHeight / 857) +
                                'px'
                            }"
                            style="font-size: 1rem; text-align: left"
                          >
                            {{
                              item.status == "S"
                                ? item.title + "-"
                                : item.title +
                                  item.load_status.load_percent +
                                  "%"
                            }}
                          </div>
                        </div>
                      </template>
                      <template v-else-if="sideBarSelect.processName == '一廠'">
                        <div
                          v-for="(item, key) in eboard_device_factory_one"
                          :key="key"
                          :id="item.device_name"
                          :style="{
                            top:
                              item.style_single.top *
                                (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style_single.left *
                                (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style_single.width *
                                (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style_single.height *
                                (home_map.clientHeight / 854) +
                              'px',
                            'background-color': item.color
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            text-align: center;
                          "
                          class="p-0"
                        ></div>
                      </template>
                      <template v-else-if="sideBarSelect.processName == '二廠'">
                        <div
                          v-for="(item, key) in eboard_device_factory_two"
                          :key="key"
                          :id="item.device_name"
                          :style="{
                            top:
                              item.style_single.top *
                                (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style_single.left *
                                (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style_single.width *
                                (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style_single.height *
                                (home_map.clientHeight / 854) +
                              'px',
                            'background-color': item.color
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            text-align: center;
                          "
                          class="p-0"
                        ></div>
                        <div
                          v-for="(item, key) in eboard_package"
                          :key="key"
                          :id="item.device_name"
                          :style="{
                            top:
                              item.style_single.top *
                                (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style_single.left *
                                (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style_single.width *
                                (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style_single.height *
                                (home_map.clientHeight / 854) +
                              'px',
                            'background-color': item.color,
                            'line-height':
                              item.style_single.height *
                                (home_map.clientHeight / 854) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            text-align: center;
                          "
                          class="px-0 py-0"
                        ></div>
                        <div
                          v-for="(item, key) in eboard_container"
                          :key="key"
                          :id="item.device_name"
                          :style="{
                            top:
                              item.style_single.top *
                                (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style_single.left *
                                (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              (item.style_single.width *
                                (home_map.clientWidth / 1890) *
                                (item.status == 'S'
                                  ? 100
                                  : item.load_status.load_percent)) /
                                100 +
                              'px',
                            height:
                              item.style_single.height *
                                (home_map.clientHeight / 854) +
                              'px',
                            'background-color': item.color
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            border-radius: 2px;
                            text-align: left;
                            padding-left: 5px;
                            overflow: visible;
                          "
                        >
                          <div
                            :style="{
                              width:
                                item.style_single.width *
                                  (home_map.clientWidth / 1890) +
                                'px',
                              'line-height':
                                item.style_single.height *
                                  (home_map.clientHeight / 854) +
                                'px'
                            }"
                            style="font-size: 1rem; text-align: left"
                          >
                            {{
                              item.status == "S"
                                ? item.title + "-"
                                : item.title +
                                  item.load_status.load_percent +
                                  "%"
                            }}
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      style="
                        position: absolute;
                        width: 100%;
                        height: calc(100vh - 150px);
                        left: 0;
                      "
                      v-resize="homeMapSize"
                    >
                      <img
                        :src="
                          sideBarSelect.processName == '全廠'
                            ? eboardFactory
                            : sideBarSelect.processName == '一廠'
                            ? eboardFactory1
                            : sideBarSelect.processName == '二廠'
                            ? eboardFactory2
                            : eboardFactory
                        "
                        ref="home_map"
                        alt=""
                        style="
                          width: 100%;
                          height: 100%;
                          left: 0px;
                          objfit: content;
                        "
                      />
                    </div>
                    <div
                      style="
                        left: 0;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                      "
                    >
                      <template v-if="sideBarSelect.processName == '全廠'">
                        <div
                          v-for="(item, key) in eboard_device_factory_one"
                          :key="key"
                          :id="item.device_name + '_factory_one'"
                          :style="{
                            top:
                              item.style.top * (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style.left * (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style.width * (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style.height *
                                (home_map.clientHeight / 854) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            background-color: transparent;
                          "
                          @click="
                            chang_page(
                              item.device_name,
                              item.process,
                              item.group
                            )
                          "
                        >
                          <b-popover
                            v-if="
                              item.device_name !== '' &&
                                ((item.shape == 'rect' &&
                                  item.color == '#00ff00') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#ffc100') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#cccdfe') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#09b0ff') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#99f98c') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#ff0000'))
                            "
                            :target="item.device_name + '_factory_one'"
                            triggers="hover"
                            placement="top"
                            custom-class="elecboard-popover"
                          >
                            {{ item.message }}
                          </b-popover>
                        </div>
                        <div
                          v-for="(item, key) in eboard_device_factory_two"
                          :key="key"
                          :id="item.device_name + '_factory_two'"
                          :style="{
                            top:
                              item.style.top * (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style.left * (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style.width * (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style.height *
                                (home_map.clientHeight / 854) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            background-color: transparent;
                          "
                          @click="
                            chang_page(
                              item.device_name,
                              item.process,
                              item.group
                            )
                          "
                        >
                          <b-popover
                            v-if="
                              item.device_name !== '' &&
                                ((item.shape == 'rect' &&
                                  item.color == '#00ff00') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#ffc100') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#cccdfe') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#09b0ff') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#99f98c') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#ff0000'))
                            "
                            :target="item.device_name + '_factory_two'"
                            triggers="hover"
                            placement="top"
                            custom-class="elecboard-popover"
                          >
                            {{ item.message }}
                          </b-popover>
                        </div>
                        <div
                          v-for="(item, key) in eboard_package"
                          :key="key"
                          :id="item.device_name + 'package_all'"
                          :style="{
                            top:
                              item.style.top * (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style.left * (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style.width * (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style.height *
                                (home_map.clientHeight / 854) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            background-color: transparent;
                          "
                          @click="
                            chang_page(
                              JSON.stringify({
                                work_code: item.work_code,
                                product_line: item.line
                              }),
                              item.process,
                              item.group
                            )
                          "
                        >
                          <b-popover
                            v-if="
                              (item.shape == 'rect' &&
                                item.color == '#00ff00') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ffc100') ||
                                (item.shape == 'rect' &&
                                  item.color == '#cccdfe') ||
                                (item.shape == 'rect' &&
                                  item.color == '#09b0ff') ||
                                (item.shape == 'rect' &&
                                  item.color == '#99f98c') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ff0000')
                            "
                            :target="item.device_name + 'package_all'"
                            triggers="hover"
                            placement="top"
                            custom-class="elecboard-popover"
                          >
                            {{ item.message }}
                          </b-popover>
                        </div>
                        <div
                          v-for="(item, key) in eboard_container"
                          :key="key"
                          :id="item.device_name + 'container_all'"
                          :style="{
                            top:
                              item.style.top * (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style.left * (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style.width * (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style.height *
                                (home_map.clientHeight / 854) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            background-color: transparent;
                          "
                          @click="
                            chang_page(
                              item.device_name,
                              item.process,
                              item.group
                            )
                          "
                        >
                          <b-popover
                            v-if="
                              (item.shape == 'rect' &&
                                item.color == '#00ff00') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ffc100') ||
                                (item.shape == 'rect' &&
                                  item.color == '#cccdfe') ||
                                (item.shape == 'rect' &&
                                  item.color == '#09b0ff') ||
                                (item.shape == 'rect' &&
                                  item.color == '#99f98c') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ff0000')
                            "
                            :target="item.device_name + 'container_all'"
                            triggers="hover"
                            placement="top"
                            custom-class="elecboard-popover"
                          >
                            {{ item.message }}
                          </b-popover>
                        </div>
                      </template>
                      <template v-else-if="sideBarSelect.processName == '一廠'">
                        <div
                          v-for="(item, key) in eboard_device_factory_one"
                          :key="key"
                          :id="item.device_name + '_factory_one_s'"
                          :style="{
                            top:
                              item.style_single.top *
                                (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style_single.left *
                                (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style_single.width *
                                (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style_single.height *
                                (home_map.clientHeight / 854) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            background-color: transparent;
                          "
                          @click="
                            chang_page(
                              item.device_name,
                              item.process,
                              item.group
                            )
                          "
                        >
                          <b-popover
                            v-if="
                              item.device_name !== '' &&
                                ((item.shape == 'rect' &&
                                  item.color == '#00ff00') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#ffc100') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#cccdfe') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#09b0ff') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#99f98c') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#ff0000'))
                            "
                            :target="item.device_name + '_factory_one_s'"
                            triggers="hover"
                            placement="top"
                            custom-class="elecboard-popover"
                          >
                            {{ item.message }}
                          </b-popover>
                        </div>
                      </template>
                      <template v-else-if="sideBarSelect.processName == '二廠'"
                        ><div
                          v-for="(item, key) in eboard_device_factory_two"
                          :key="key"
                          :id="item.device_name + '_factory_two_s'"
                          :style="{
                            top:
                              item.style_single.top *
                                (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style_single.left *
                                (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style_single.width *
                                (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style_single.height *
                                (home_map.clientHeight / 854) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            background-color: transparent;
                          "
                          @click="
                            chang_page(
                              item.device_name,
                              item.process,
                              item.group
                            )
                          "
                        >
                          <b-popover
                            v-if="
                              item.device_name !== '' &&
                                ((item.shape == 'rect' &&
                                  item.color == '#00ff00') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#ffc100') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#cccdfe') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#09b0ff') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#99f98c') ||
                                  (item.shape == 'rect' &&
                                    item.color == '#ff0000'))
                            "
                            :target="item.device_name + '_factory_two_s'"
                            triggers="hover"
                            placement="top"
                            custom-class="elecboard-popover"
                          >
                            {{ item.message }}
                          </b-popover>
                        </div>
                        <div
                          v-for="(item, key) in eboard_package"
                          :key="key"
                          :id="item.device_name + '_package_s'"
                          :style="{
                            top:
                              item.style_single.top *
                                (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style_single.left *
                                (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style_single.width *
                                (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style_single.height *
                                (home_map.clientHeight / 854) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            background-color: transparent;
                          "
                          @click="
                            chang_page(
                              JSON.stringify({
                                work_code: item.work_code,
                                product_line: item.line
                              }),
                              item.process,
                              item.group
                            )
                          "
                        >
                          <b-popover
                            v-if="
                              (item.shape == 'rect' &&
                                item.color == '#00ff00') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ffc100') ||
                                (item.shape == 'rect' &&
                                  item.color == '#cccdfe') ||
                                (item.shape == 'rect' &&
                                  item.color == '#09b0ff') ||
                                (item.shape == 'rect' &&
                                  item.color == '#99f98c') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ff0000')
                            "
                            :target="item.device_name + '_package_s'"
                            triggers="hover"
                            placement="top"
                            custom-class="elecboard-popover"
                          >
                            {{ item.message }}
                          </b-popover>
                        </div>
                        <div
                          v-for="(item, key) in eboard_container"
                          :key="key"
                          :id="item.device_name + '_container_s'"
                          :style="{
                            top:
                              item.style_single.top *
                                (home_map.clientHeight / 854) +
                              'px',
                            left:
                              item.style_single.left *
                                (home_map.clientWidth / 1890) +
                              'px',
                            width:
                              item.style_single.width *
                                (home_map.clientWidth / 1890) +
                              'px',
                            height:
                              item.style_single.height *
                                (home_map.clientHeight / 854) +
                              'px'
                          }"
                          style="
                            position: absolute;
                            cursor: pointer;
                            background-color: transparent;
                          "
                          @click="
                            chang_page(
                              item.device_name,
                              item.process,
                              item.group
                            )
                          "
                        >
                          <b-popover
                            v-if="
                              (item.shape == 'rect' &&
                                item.color == '#00ff00') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ffc100') ||
                                (item.shape == 'rect' &&
                                  item.color == '#cccdfe') ||
                                (item.shape == 'rect' &&
                                  item.color == '#09b0ff') ||
                                (item.shape == 'rect' &&
                                  item.color == '#99f98c') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ff0000')
                            "
                            :target="item.device_name + '_container_s'"
                            triggers="hover"
                            placement="top"
                            custom-class="elecboard-popover"
                          >
                            {{ item.message }}
                          </b-popover>
                        </div>
                      </template>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "home",
  data() {
    return {
      noBorderCollapse: true,
      nowtime: "--",
      erro_detail_device_name: "",
      erro_detail: false,
      home_map: {
        clientWidth: 1696,
        clientHeight: 787
      },
      erro_status_fields: [
        {
          key: "process",
          label: "製程",
          sortable: false
          // class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "device_name",
          label: "機台",
          sortable: false
          // class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "machine_abn_id",
          label: "警報代碼",
          sortable: false
          // class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "machine_abn_description",
          label: "警報說明",
          sortable: false
          // class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "machine_video",
          label: "機台影像",
          sortable: false
          // class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
          key: "machine_erro_time",
          label: "開始時間",
          sortable: false
          // class: "font-family-dfyuanstd-w5 table-col-hight",
        }
      ],
      erro_status_item: [],
      eboardFactory: require("../assets/eboard-factory-new.png"),
      eboardFactory1: require("../assets/eboard-factory1.png"),
      eboardFactory2: require("../assets/eboard-factory2.png"),
      eboard_device_factory_show: [],
      eboard_device_factory_one: [
        {
          device_name: "A",
          message: "熱處理A，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 13,
            width: 335,
            height: 64
          },
          style_single: {
            top: 23,
            left: 27,
            width: 693,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heat-treatment",
          group: "heat-treatment1"
        },
        {
          device_name: "B",
          message: "熱處理B，2021-11-05 10:27:27",
          style: {
            top: 116,
            left: 13,
            width: 335,
            height: 64
          },
          style_single: {
            top: 116,
            left: 27,
            width: 693,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heat-treatment",
          group: "heat-treatment1"
        },
        {
          device_name: "C",
          message: "熱處理C，2021-11-05 10:27:27",
          style: {
            top: 209,
            left: 13,
            width: 335,
            height: 64
          },
          style_single: {
            top: 209,
            left: 27,
            width: 693,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heat-treatment",
          group: "heat-treatment1"
        },
        {
          device_name: "D",
          message: "熱處理D，2021-11-05 10:27:27",
          style: {
            top: 302,
            left: 13,
            width: 335,
            height: 64
          },
          style_single: {
            top: 302,
            left: 27,
            width: 693,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heat-treatment",
          group: "heat-treatment1"
        },
        {
          device_name: "E",
          message: "熱處理E，2021-11-05 10:27:27",
          style: {
            top: 394,
            left: 13,
            width: 335,
            height: 64
          },
          style_single: {
            top: 394,
            left: 27,
            width: 693,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heat-treatment",
          group: "heat-treatment1"
        },
        {
          device_name: "B48",
          message: "打頭B48，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 752,
            width: 174,
            height: 64
          },
          style_single: {
            top: 23,
            left: 1507,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        },
        {
          device_name: "T98",
          message: "輾牙T98，2021-11-05 10:27:27",
          style: {
            top: 112,
            left: 507,
            width: 44,
            height: 64
          },
          style_single: {
            top: 112,
            left: 1017,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T68",
          message: "輾牙T68，2021-11-05 10:27:27",
          style: {
            top: 112,
            left: 565,
            width: 44,
            height: 64
          },
          style_single: {
            top: 112,
            left: 1139,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T64",
          message: "輾牙T64，2021-11-05 10:27:27",
          style: {
            top: 112,
            left: 623,
            width: 44,
            height: 64
          },
          style_single: {
            top: 112,
            left: 1260,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "B47",
          message: "打頭B47，2021-11-05 10:27:27",
          style: {
            top: 112,
            left: 752,
            width: 174,
            height: 64
          },
          style_single: {
            top: 112,
            left: 1507,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        },
        {
          device_name: "B49",
          message: "打頭B49，2021-11-05 10:27:27",
          style: {
            top: 200,
            left: 376,
            width: 174,
            height: 64
          },
          style_single: {
            top: 200,
            left: 772,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B06",
          message: "打頭B06，2021-11-05 10:27:27",
          style: {
            top: 200,
            left: 564,
            width: 174,
            height: 64
          },
          style_single: {
            top: 200,
            left: 1139,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        },
        {
          device_name: "B50",
          message: "打頭B50，2021-11-05 10:27:27",
          style: {
            top: 200,
            left: 752,
            width: 174,
            height: 64
          },
          style_single: {
            top: 200,
            left: 1507,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        },
        {
          device_name: "B51",
          message: "打頭B51，2021-11-05 10:27:27",
          style: {
            top: 288,
            left: 376,
            width: 175,
            height: 64
          },
          style_single: {
            top: 288,
            left: 772,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        },
        {
          device_name: "B07",
          message: "打頭B07，2021-11-05 10:27:27",
          style: {
            top: 288,
            left: 564,
            width: 174,
            height: 64
          },
          style_single: {
            top: 288,
            left: 1139,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        },
        {
          device_name: "B52",
          message: "打頭B52，2021-11-05 10:27:27",
          style: {
            top: 288,
            left: 752,
            width: 174,
            height: 64
          },
          style_single: {
            top: 288,
            left: 1507,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        },
        {
          device_name: "B44",
          message: "打頭B44，2021-11-05 10:27:27",
          style: {
            top: 419,
            left: 376,
            width: 165,
            height: 64
          },
          style_single: {
            top: 419,
            left: 772,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B34",
          message: "打頭B34，2021-11-05 10:27:27",
          style: {
            top: 377,
            left: 555,
            width: 41,
            height: 106
          },
          style_single: {
            top: 377,
            left: 1144,
            width: 80,
            height: 104
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B32",
          message: "打頭B32，2021-11-05 10:27:27",
          style: {
            top: 377,
            left: 602,
            width: 41,
            height: 106
          },
          style_single: {
            top: 377,
            left: 1234,
            width: 80,
            height: 104
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B33",
          message: "打頭B33，2021-11-05 10:27:27",
          style: {
            top: 377,
            left: 649,
            width: 41,
            height: 106
          },
          style_single: {
            top: 377,
            left: 1324,
            width: 80,
            height: 104
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B36",
          message: "打頭B36，2021-11-05 10:27:27",
          style: {
            top: 377,
            left: 696,
            width: 41,
            height: 106
          },
          style_single: {
            top: 377,
            left: 1414,
            width: 80,
            height: 104
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B39",
          message: "打頭B39，2021-11-05 10:27:27",
          style: {
            top: 377,
            left: 743,
            width: 41,
            height: 106
          },
          style_single: {
            top: 377,
            left: 1503,
            width: 80,
            height: 104
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B38",
          message: "打頭B38，2021-11-05 10:27:27",
          style: {
            top: 377,
            left: 790,
            width: 41,
            height: 106
          },
          style_single: {
            top: 377,
            left: 1593,
            width: 80,
            height: 104
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B35",
          message: "打頭B35，2021-11-05 10:27:27",
          style: {
            top: 377,
            left: 837,
            width: 41,
            height: 106
          },
          style_single: {
            top: 377,
            left: 1683,
            width: 80,
            height: 104
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "T69",
          message: "輾牙T69，2021-11-05 10:27:27",
          style: {
            top: 507,
            left: 16,
            width: 44,
            height: 64
          },
          style_single: {
            top: 507,
            left: 37,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "B14",
          message: "打頭B14，2021-11-05 10:27:27",
          style: {
            top: 507,
            left: 196,
            width: 165,
            height: 64
          },
          style_single: {
            top: 507,
            left: 404,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B16",
          message: "打頭B16，2021-11-05 10:27:27",
          style: {
            top: 507,
            left: 376,
            width: 165,
            height: 64
          },
          style_single: {
            top: 507,
            left: 772,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B54",
          message: "打頭B54，2021-11-05 10:27:27",
          style: {
            top: 507,
            left: 555,
            width: 41,
            height: 89
          },
          style_single: {
            top: 507,
            left: 1144,
            width: 80,
            height: 105
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B53",
          message: "打頭B53，2021-11-05 10:27:27",
          style: {
            top: 507,
            left: 610,
            width: 41,
            height: 89
          },
          style_single: {
            top: 507,
            left: 1249,
            width: 80,
            height: 105
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B37",
          message: "打頭B37，2021-11-05 10:27:27",
          style: {
            top: 507,
            left: 665,
            width: 41,
            height: 89
          },
          style_single: {
            top: 507,
            left: 1353,
            width: 80,
            height: 105
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B57",
          message: "打頭B57，2021-11-05 10:27:27",
          style: {
            top: 507,
            left: 719,
            width: 41,
            height: 89
          },
          style_single: {
            top: 507,
            left: 1458,
            width: 80,
            height: 105
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B56",
          message: "打頭B56，2021-11-05 10:27:27",
          style: {
            top: 507,
            left: 774,
            width: 41,
            height: 89
          },
          style_single: {
            top: 507,
            left: 1563,
            width: 80,
            height: 105
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "B55",
          message: "打頭B55，2021-11-05 10:27:27",
          style: {
            top: 507,
            left: 829,
            width: 41,
            height: 89
          },
          style_single: {
            top: 507,
            left: 1668,
            width: 80,
            height: 105
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading2"
        },
        {
          device_name: "T53",
          message: "輾牙T53，2021-11-05 10:27:27",
          style: {
            top: 595,
            left: 16,
            width: 44,
            height: 64
          },
          style_single: {
            top: 595,
            left: 37,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T28",
          message: "輾牙T28，2021-11-05 10:27:27",
          style: {
            top: 595,
            left: 76,
            width: 44,
            height: 64
          },
          style_single: {
            top: 595,
            left: 159,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T70",
          message: "輾牙T70，2021-11-05 10:27:27",
          style: {
            top: 595,
            left: 136,
            width: 44,
            height: 64
          },
          style_single: {
            top: 595,
            left: 281,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T71",
          message: "輾牙T71，2021-11-05 10:27:27",
          style: {
            top: 595,
            left: 196,
            width: 44,
            height: 64
          },
          style_single: {
            top: 595,
            left: 404,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T23",
          message: "輾牙T23，2021-11-05 10:27:27",
          style: {
            top: 595,
            left: 256,
            width: 44,
            height: 64
          },
          style_single: {
            top: 595,
            left: 526,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T24",
          message: "輾牙T24，2021-11-05 10:27:27",
          style: {
            top: 595,
            left: 316,
            width: 44,
            height: 64
          },
          style_single: {
            top: 595,
            left: 649,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "B46",
          message: "打頭B46，2021-11-05 10:27:27",
          style: {
            top: 595,
            left: 376,
            width: 165,
            height: 64
          },
          style_single: {
            top: 595,
            left: 772,
            width: 343,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        },
        {
          device_name: "T54",
          message: "輾牙T54，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 16,
            width: 44,
            height: 64
          },
          style_single: {
            top: 684,
            left: 37,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T65",
          message: "輾牙T65，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 76,
            width: 44,
            height: 64
          },
          style_single: {
            top: 684,
            left: 159,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T51",
          message: "輾牙T51，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 136,
            width: 44,
            height: 64
          },
          style_single: {
            top: 684,
            left: 281,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T17",
          message: "輾牙T17，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 196,
            width: 44,
            height: 64
          },
          style_single: {
            top: 684,
            left: 404,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T18",
          message: "輾牙T18，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 256,
            width: 44,
            height: 64
          },
          style_single: {
            top: 684,
            left: 526,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T22",
          message: "輾牙T22，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 316,
            width: 44,
            height: 64
          },
          style_single: {
            top: 684,
            left: 649,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T47",
          message: "輾牙T47，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 376,
            width: 44,
            height: 64
          },
          style_single: {
            top: 684,
            left: 772,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T43",
          message: "輾牙T43，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 436,
            width: 44,
            height: 64
          },
          style_single: {
            top: 684,
            left: 894,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T61",
          message: "輾牙T61，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 496,
            width: 44,
            height: 64
          },
          style_single: {
            top: 684,
            left: 1016,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "B12",
          message: "打頭B12，2021-11-05 10:27:27",
          style: {
            top: 684,
            left: 620,
            width: 174,
            height: 64
          },
          style_single: {
            top: 684,
            left: 1270,
            width: 338,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        },
        {
          device_name: "T101",
          message: "輾牙T101，2021-11-05 10:27:27",
          style: {
            top: 772,
            left: 16,
            width: 44,
            height: 64
          },
          style_single: {
            top: 772,
            left: 37,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T100",
          message: "輾牙T100，2021-11-05 10:27:27",
          style: {
            top: 772,
            left: 76,
            width: 44,
            height: 64
          },
          style_single: {
            top: 772,
            left: 159,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "R09",
          message: "輾牙R09，2021-11-05 10:27:27",
          style: {
            top: 772,
            left: 136,
            width: 44,
            height: 64
          },
          style_single: {
            top: 772,
            left: 281,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T102",
          message: "輾牙T102，2021-11-05 10:27:27",
          style: {
            top: 772,
            left: 196,
            width: 44,
            height: 64
          },
          style_single: {
            top: 772,
            left: 404,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T103",
          message: "輾牙T103，2021-11-05 10:27:27",
          style: {
            top: 772,
            left: 256,
            width: 44,
            height: 64
          },
          style_single: {
            top: 772,
            left: 526,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T13",
          message: "輾牙T13，2021-11-05 10:27:27",
          style: {
            top: 772,
            left: 316,
            width: 44,
            height: 64
          },
          style_single: {
            top: 772,
            left: 649,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "T14",
          message: "輾牙T14，2021-11-05 10:27:27",
          style: {
            top: 772,
            left: 376,
            width: 44,
            height: 64
          },
          style_single: {
            top: 772,
            left: 772,
            width: 98,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling1"
        },
        {
          device_name: "B10",
          message: "打頭B10，2021-11-05 10:27:27",
          style: {
            top: 772,
            left: 620,
            width: 174,
            height: 64
          },
          style_single: {
            top: 772,
            left: 1270,
            width: 338,
            height: 64
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading1"
        }
      ],
      eboard_device_factory_two: [
        {
          device_name: "D2",
          message: "熱處理D2，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 957,
            width: 115,
            height: 154
          },
          style_single: {
            top: 23,
            left: 22,
            width: 289,
            height: 146
          },
          shape: "rect",
          color: "#cccccc",
          process: "heat-treatment",
          group: "heat-treatment2"
        },
        {
          device_name: "A2",
          message: "熱處理A2，2021-11-05 10:27:27",
          style: {
            top: 192,
            left: 957,
            width: 115,
            height: 154
          },
          style_single: {
            top: 183,
            left: 22,
            width: 289,
            height: 146
          },
          shape: "rect",
          color: "#cccccc",
          process: "heat-treatment",
          group: "heat-treatment2"
        },
        {
          device_name: "B2",
          message: "熱處理B2，2021-11-05 10:27:27",
          style: {
            top: 360,
            left: 957,
            width: 115,
            height: 154
          },
          style_single: {
            top: 343,
            left: 22,
            width: 289,
            height: 146
          },
          shape: "rect",
          color: "#cccccc",
          process: "heat-treatment",
          group: "heat-treatment2"
        },
        {
          device_name: "C2",
          message: "熱處理C2，2021-11-05 10:27:27",
          style: {
            top: 529,
            left: 957,
            width: 115,
            height: 154
          },
          style_single: {
            top: 503,
            left: 22,
            width: 289,
            height: 146
          },
          shape: "rect",
          color: "#cccccc",
          process: "heat-treatment",
          group: "heat-treatment2"
        },
        {
          device_name: "T01",
          message: "輾牙T01，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1087,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 337,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R06",
          message: "輾牙R06，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1142,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 438,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R05",
          message: "輾牙R05，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1197,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 539,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R16",
          message: "輾牙R16，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1252,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 640,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R08",
          message: "輾牙R08，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1307,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 740,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "F07",
          message: "打頭F07，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1370,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 870,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F08",
          message: "打頭F08，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1423,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 972,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F09",
          message: "打頭F09，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1475,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 1073,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F10",
          message: "打頭F10，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1527,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 1174,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F11",
          message: "打頭F11，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1580,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 1275,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "B29",
          message: "打頭B29，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1632,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 1376,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F39",
          message: "打頭F39，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1684,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 1477,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F40",
          message: "打頭F40，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1737,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 1578,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F41",
          message: "打頭F41，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1788,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 1679,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F42",
          message: "打頭F42，2021-11-05 10:27:27",
          style: {
            top: 23,
            left: 1839,
            width: 41,
            height: 59
          },
          style_single: {
            top: 23,
            left: 1780,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "R03",
          message: "輾牙R03，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1142,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 438,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R02",
          message: "輾牙R02，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1197,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 539,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R01",
          message: "輾牙R01，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1252,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 640,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "F06",
          message: "打頭F06，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1370,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 870,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F05",
          message: "打頭F05，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1423,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 972,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F04",
          message: "打頭F04，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1475,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 1073,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F03",
          message: "打頭F03，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1527,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 1174,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F51",
          message: "打頭F51，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1580,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 1275,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F13",
          message: "打頭F13，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1684,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 1477,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F14",
          message: "打頭F14，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1737,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 1578,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F33",
          message: "打頭F33，2021-11-05 10:27:27",
          style: {
            top: 97,
            left: 1788,
            width: 41,
            height: 59
          },
          style_single: {
            top: 94,
            left: 1679,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "R37",
          message: "輾牙R37，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1087,
            width: 41,
            height: 59
          },
          style_single: {
            top: 165,
            left: 337,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R36",
          message: "輾牙R36，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1142,
            width: 41,
            height: 59
          },
          style_single: {
            top: 165,
            left: 438,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R35",
          message: "輾牙R35，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1197,
            width: 41,
            height: 59
          },
          style_single: {
            top: 165,
            left: 539,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R34",
          message: "輾牙R34，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1252,
            width: 41,
            height: 59
          },
          style_single: {
            top: 165,
            left: 640,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R33",
          message: "輾牙R33，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1307,
            width: 41,
            height: 59
          },
          style_single: {
            top: 165,
            left: 740,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "B30",
          message: "打頭B30，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1370,
            width: 41,
            height: 137
          },
          style_single: {
            top: 165,
            left: 870,
            width: 75,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F52",
          message: "打頭F52，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1423,
            width: 41,
            height: 137
          },
          style_single: {
            top: 165,
            left: 972,
            width: 75,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "B45",
          message: "打頭B45，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1632,
            width: 41,
            height: 137
          },
          style_single: {
            top: 165,
            left: 1376,
            width: 74,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F38",
          message: "打頭F38，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1684,
            width: 41,
            height: 137
          },
          style_single: {
            top: 165,
            left: 1477,
            width: 74,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "R27",
          message: "輾牙R27，2021-11-05 10:27:27",
          style: {
            top: 248,
            left: 1087,
            width: 41,
            height: 59
          },
          style_single: {
            top: 236,
            left: 337,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R20",
          message: "輾牙R20，2021-11-05 10:27:27",
          style: {
            top: 248,
            left: 1142,
            width: 41,
            height: 59
          },
          style_single: {
            top: 236,
            left: 438,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R19",
          message: "輾牙R19，2021-11-05 10:27:27",
          style: {
            top: 248,
            left: 1197,
            width: 41,
            height: 59
          },
          style_single: {
            top: 236,
            left: 539,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R17",
          message: "輾牙R17，2021-11-05 10:27:27",
          style: {
            top: 248,
            left: 1252,
            width: 41,
            height: 59
          },
          style_single: {
            top: 236,
            left: 640,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R26",
          message: "輾牙R26，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1087,
            width: 41,
            height: 59
          },
          style_single: {
            top: 307,
            left: 337,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R23",
          message: "輾牙R23，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1142,
            width: 41,
            height: 59
          },
          style_single: {
            top: 307,
            left: 438,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R22",
          message: "輾牙R22，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1197,
            width: 41,
            height: 59
          },
          style_single: {
            top: 307,
            left: 539,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R21",
          message: "輾牙R21，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1252,
            width: 41,
            height: 59
          },
          style_single: {
            top: 307,
            left: 640,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "F15",
          message: "打頭F15，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1370,
            width: 41,
            height: 137
          },
          style_single: {
            top: 307,
            left: 870,
            width: 75,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F16",
          message: "打頭F16，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1423,
            width: 41,
            height: 137
          },
          style_single: {
            top: 307,
            left: 972,
            width: 74,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F17",
          message: "打頭F17，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1475,
            width: 41,
            height: 137
          },
          style_single: {
            top: 307,
            left: 1073,
            width: 74,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F34",
          message: "打頭F34，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1527,
            width: 41,
            height: 137
          },
          style_single: {
            top: 307,
            left: 1174,
            width: 74,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F35",
          message: "打頭F35，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1580,
            width: 41,
            height: 137
          },
          style_single: {
            top: 307,
            left: 1275,
            width: 74,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F36",
          message: "打頭F36，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1632,
            width: 41,
            height: 137
          },
          style_single: {
            top: 307,
            left: 1376,
            width: 74,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "F37",
          message: "打頭F37，2021-11-05 10:27:27",
          style: {
            top: 322,
            left: 1684,
            width: 41,
            height: 137
          },
          style_single: {
            top: 307,
            left: 1477,
            width: 74,
            height: 130
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading5"
        },
        {
          device_name: "S06",
          message: "輾牙S06，2021-11-05 10:27:27",
          style: {
            top: 400,
            left: 1087,
            width: 41,
            height: 59
          },
          style_single: {
            top: 378,
            left: 337,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "S05",
          message: "輾牙S05，2021-11-05 10:27:27",
          style: {
            top: 400,
            left: 1142,
            width: 41,
            height: 59
          },
          style_single: {
            top: 378,
            left: 438,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "S04",
          message: "輾牙S04，2021-11-05 10:27:27",
          style: {
            top: 400,
            left: 1197,
            width: 41,
            height: 59
          },
          style_single: {
            top: 378,
            left: 539,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "S43",
          message: "輾牙S43，2021-11-05 10:27:27",
          style: {
            top: 400,
            left: 1252,
            width: 41,
            height: 59
          },
          style_single: {
            top: 378,
            left: 640,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R28",
          message: "輾牙R28，2021-11-05 10:27:27",
          style: {
            top: 400,
            left: 1307,
            width: 41,
            height: 59
          },
          style_single: {
            top: 378,
            left: 740,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "T11",
          message: "輾牙T11，2021-11-05 10:27:27",
          style: {
            top: 474,
            left: 1087,
            width: 41,
            height: 59
          },
          style_single: {
            top: 448,
            left: 337,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "T09",
          message: "輾牙T09，2021-11-05 10:27:27",
          style: {
            top: 474,
            left: 1142,
            width: 41,
            height: 59
          },
          style_single: {
            top: 448,
            left: 438,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R04",
          message: "輾牙R04，2021-11-05 10:27:27",
          style: {
            top: 474,
            left: 1197,
            width: 41,
            height: 59
          },
          style_single: {
            top: 448,
            left: 539,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R25",
          message: "輾牙R25，2021-11-05 10:27:27",
          style: {
            top: 474,
            left: 1252,
            width: 41,
            height: 59
          },
          style_single: {
            top: 448,
            left: 640,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R24",
          message: "輾牙R24，2021-11-05 10:27:27",
          style: {
            top: 474,
            left: 1307,
            width: 41,
            height: 59
          },
          style_single: {
            top: 448,
            left: 740,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "B19",
          message: "打頭B19，2021-11-05 10:27:27",
          style: {
            top: 475,
            left: 1369,
            width: 63,
            height: 59
          },
          style_single: {
            top: 448,
            left: 872,
            width: 122,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "B20",
          message: "打頭B20，2021-11-05 10:27:27",
          style: {
            top: 475,
            left: 1442,
            width: 64,
            height: 59
          },
          style_single: {
            top: 448,
            left: 1012,
            width: 120,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "B15",
          message: "打頭B15，2021-11-05 10:27:27",
          style: {
            top: 475,
            left: 1515,
            width: 64,
            height: 59
          },
          style_single: {
            top: 448,
            left: 1152,
            width: 120,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F32",
          message: "打頭F32，2021-11-05 10:27:27",
          style: {
            top: 475,
            left: 1588,
            width: 63,
            height: 59
          },
          style_single: {
            top: 448,
            left: 1292,
            width: 120,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F43",
          message: "打頭F43，2021-11-05 10:27:27",
          style: {
            top: 475,
            left: 1662,
            width: 63,
            height: 59
          },
          style_single: {
            top: 448,
            left: 1432,
            width: 120,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "S49",
          message: "輾牙S49，2021-11-05 10:27:27",
          style: {
            top: 548,
            left: 1087,
            width: 41,
            height: 59
          },
          style_single: {
            top: 519,
            left: 337,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R18",
          message: "輾牙R18，2021-11-05 10:27:27",
          style: {
            top: 548,
            left: 1142,
            width: 41,
            height: 59
          },
          style_single: {
            top: 519,
            left: 438,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "T99",
          message: "輾牙T99，2021-11-05 10:27:27",
          style: {
            top: 548,
            left: 1197,
            width: 41,
            height: 59
          },
          style_single: {
            top: 519,
            left: 539,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R11",
          message: "輾牙R11，2021-11-05 10:27:27",
          style: {
            top: 548,
            left: 1252,
            width: 41,
            height: 59
          },
          style_single: {
            top: 519,
            left: 640,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R10",
          message: "輾牙R10，2021-11-05 10:27:27",
          style: {
            top: 548,
            left: 1307,
            width: 41,
            height: 59
          },
          style_single: {
            top: 519,
            left: 740,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "B18",
          message: "打頭B18，2021-11-05 10:27:27",
          style: {
            top: 548,
            left: 1369,
            width: 63,
            height: 59
          },
          style_single: {
            top: 519,
            left: 872,
            width: 122,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "B21",
          message: "打頭B21，2021-11-05 10:27:27",
          style: {
            top: 548,
            left: 1442,
            width: 64,
            height: 59
          },
          style_single: {
            top: 519,
            left: 1012,
            width: 120,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "B17",
          message: "打頭B17，2021-11-05 10:27:27",
          style: {
            top: 548,
            left: 1515,
            width: 64,
            height: 59
          },
          style_single: {
            top: 519,
            left: 1152,
            width: 120,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F31",
          message: "打頭F31，2021-11-05 10:27:27",
          style: {
            top: 548,
            left: 1588,
            width: 63,
            height: 59
          },
          style_single: {
            top: 519,
            left: 1292,
            width: 120,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "R40",
          message: "輾牙R40，2021-11-05 10:27:27",
          style: {
            top: 622,
            left: 1197,
            width: 41,
            height: 59
          },
          style_single: {
            top: 590,
            left: 539,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R39",
          message: "輾牙R39，2021-11-05 10:27:27",
          style: {
            top: 622,
            left: 1252,
            width: 41,
            height: 59
          },
          style_single: {
            top: 590,
            left: 640,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R38",
          message: "輾牙R38，2021-11-05 10:27:27",
          style: {
            top: 622,
            left: 1307,
            width: 41,
            height: 59
          },
          style_single: {
            top: 590,
            left: 740,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R32",
          message: "輾牙R32，2021-11-05 10:27:27",
          style: {
            top: 622,
            left: 1369,
            width: 41,
            height: 59
          },
          style_single: {
            top: 590,
            left: 872,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R31",
          message: "輾牙R31，2021-11-05 10:27:27",
          style: {
            top: 622,
            left: 1424,
            width: 41,
            height: 59
          },
          style_single: {
            top: 590,
            left: 966,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R30",
          message: "輾牙R30，2021-11-05 10:27:27",
          style: {
            top: 622,
            left: 1480,
            width: 41,
            height: 59
          },
          style_single: {
            top: 590,
            left: 1066,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "R29",
          message: "輾牙R29，2021-11-05 10:27:27",
          style: {
            top: 622,
            left: 1535,
            width: 41,
            height: 59
          },
          style_single: {
            top: 590,
            left: 1167,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "thread-rolling",
          group: "thread-rolling2"
        },
        {
          device_name: "F44",
          message: "打頭F44，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1788,
            width: 41,
            height: 59
          },
          style_single: {
            top: 166,
            left: 1679,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "B05",
          message: "打頭B05，2021-11-05 10:27:27",
          style: {
            top: 170,
            left: 1839,
            width: 41,
            height: 59
          },
          style_single: {
            top: 166,
            left: 1780,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F45",
          message: "打頭F45，2021-11-05 10:27:27",
          style: {
            top: 248,
            left: 1788,
            width: 41,
            height: 59
          },
          style_single: {
            top: 248,
            left: 1679,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F12",
          message: "打頭F12，2021-11-05 10:27:27",
          style: {
            top: 248,
            left: 1839,
            width: 41,
            height: 59
          },
          style_single: {
            top: 248,
            left: 1780,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F46",
          message: "打頭F46，2021-11-05 10:27:27",
          style: {
            top: 327,
            left: 1788,
            width: 41,
            height: 59
          },
          style_single: {
            top: 329,
            left: 1679,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "B02",
          message: "打頭B02，2021-11-05 10:27:27",
          style: {
            top: 327,
            left: 1839,
            width: 41,
            height: 59
          },
          style_single: {
            top: 329,
            left: 1780,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F47",
          message: "打頭F47，2021-11-05 10:27:27",
          style: {
            top: 404,
            left: 1788,
            width: 41,
            height: 59
          },
          style_single: {
            top: 412,
            left: 1679,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "B01",
          message: "打頭B01，2021-11-05 10:27:27",
          style: {
            top: 404,
            left: 1839,
            width: 41,
            height: 59
          },
          style_single: {
            top: 412,
            left: 1780,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F48",
          message: "打頭F48，2021-11-05 10:27:27",
          style: {
            top: 482,
            left: 1788,
            width: 41,
            height: 59
          },
          style_single: {
            top: 494,
            left: 1679,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F50",
          message: "打頭F50，2021-11-05 10:27:27",
          style: {
            top: 482,
            left: 1839,
            width: 41,
            height: 59
          },
          style_single: {
            top: 494,
            left: 1780,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        },
        {
          device_name: "F49",
          message: "打頭F49，2021-11-05 10:27:27",
          style: {
            top: 559,
            left: 1788,
            width: 41,
            height: 59
          },
          style_single: {
            top: 577,
            left: 1679,
            width: 75,
            height: 59
          },
          shape: "rect",
          color: "#cccccc",
          process: "heading",
          group: "heading4"
        }
      ],
      eboard_package: [
        {
          device_name: "PK01",
          line: "01",
          message: "包裝01線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1771,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 1642,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK02",
          line: "02",
          message: "包裝02線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1697,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 1495,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK03",
          line: "03",
          message: "包裝03線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1623,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 1346,
            width: 124,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK04",
          line: "04",
          message: "包裝04線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1549,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 1200,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK05",
          line: "05",
          message: "包裝05線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1474,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 1053,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK06",
          line: "06",
          message: "包裝06線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1400,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 905,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK07",
          line: "07",
          message: "包裝07線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1326,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 758,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK08",
          line: "08",
          message: "包裝08線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1252,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 611,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK09",
          line: "09",
          message: "包裝09線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1178,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 464,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK10",
          line: "10",
          message: "包裝10線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1105,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 316,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK11",
          line: "11",
          message: "包裝11線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 1030,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 169,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        },
        {
          device_name: "PK12",
          line: "12",
          message: "包裝12線，2021-07-27 07:27:27",
          style: {
            top: 719,
            left: 957,
            width: 47,
            height: 47
          },
          style_single: {
            top: 697,
            left: 22,
            width: 123,
            height: 60
          },
          shape: "rect",
          color: "#cccccc",
          process: "package",
          group: "package"
        }
      ],
      eboard_container: [
        {
          device_name: "A1",
          message: "裝櫃A1，2021-07-27 07:27:27",
          title: "",
          style: {
            top: 783,
            left: 984,
            width: 195,
            height: 42
          },
          style_single: {
            top: 777,
            left: 131,
            width: 306,
            height: 42
          },
          shape: "rect",
          color: "#cccccc",
          process: "container-load",
          group: "container-load",
          load_status: {
            load_percent: 0,
            now_load: 0,
            total_load: 0
          },
          status: "S"
        },
        {
          device_name: "A2",
          message: "裝櫃A2，2021-07-27 07:27:27",
          title: "",
          style: {
            top: 783,
            left: 1280,
            width: 195,
            height: 42
          },
          style_single: {
            top: 777,
            left: 720,
            width: 306,
            height: 42
          },
          shape: "rect",
          color: "#cccccc",
          process: "container-load",
          group: "container-load",
          load_status: {
            load_percent: 0,
            now_load: 0,
            total_load: 0
          },
          status: "S"
        },
        {
          device_name: "A3",
          message: "裝櫃A3，2021-07-27 07:27:27",
          title: "",
          style: {
            top: 783,
            left: 1576,
            width: 195,
            height: 42
          },
          style_single: {
            top: 777,
            left: 1310,
            width: 306,
            height: 42
          },
          shape: "rect",
          color: "#cccccc",
          process: "container-load",
          group: "container-load",
          load_status: {
            load_percent: 0,
            now_load: 0,
            total_load: 0
          },
          status: "S"
        }
      ],
      err_status_data: [],
      result_Data: {
        work_percent: 25
      },
      query_counter: 0
    };
  },
  components: {},
  watch: {
    query_counter: {
      handler() {
        let vm = this;
        if (vm.query_counter >= 1500) {
          window.location.reload();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      axiosResult: "commonaxios/get_axiosResult",
      sideBarSelect: "sideBarTree/get_sideBarSelect",
      sideBarLeft: "sideBarTree/get_sideBarLeft"
    })
  },
  created: function() {
    window.addEventListener("beforeunload", this.setSessionItems);
    let factory_id = sessionStorage.getItem("mes_home_selected");
    let selected_factory = "all";
    if (factory_id == "一廠") {
      selected_factory = "factory1";
    } else if (factory_id == "二廠") {
      selected_factory = "factory2";
    } else {
      selected_factory = "all";
    }
    this.set_sideBarSelect(["home", selected_factory]);
    this.change_selectPage("home");
    this.change_selectPageName(this.pageName.home);
    let vm = this;
    vm.get_factory_data();
    sessionStorage.removeItem("mes_home_selected");
  },
  mounted: function() {
    let vm = this;

    window.addEventListener("resize", function() {
      if (vm.$refs.home_map != undefined) {
        if (vm.$refs.home_map.clientWidth != undefined) {
          vm.home_map.clientWidth = vm.$refs.home_map.clientWidth;
        }
        if (vm.$refs.home_map.clientHeight != undefined) {
          vm.home_map.clientHeight = vm.$refs.home_map.clientHeight;
        }
      }
    });
    setTimeout(function() {
      vm.eboard_container.forEach((item, key) => {
        vm.eboard_container[key].title = item.device_name + "裝櫃狀態:";
      });
      //總覽圖片
      if (vm.$refs.home_map.clientWidth != undefined) {
        vm.home_map.clientWidth = vm.$refs.home_map.clientWidth;
      }
      if (vm.$refs.home_map.clientHeight != undefined) {
        vm.home_map.clientHeight = vm.$refs.home_map.clientHeight;
      }
    }, 200);
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_deviceName: "selectDevice/set_deviceName",
      set_shipmentProcess: "selectDevice/set_shipmentProcess",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect",
      set_previousPage: "previousPage/set_previousPage"
    }),
    chang_page(device_name, process, group) {
      let vm = this;
      let has_device = false;
      if (device_name == "") return;
      if (
        process == "heading" ||
        process == "thread-rolling" ||
        process == "heat-treatment"
      ) {
        vm.eboard_device_factory_one.forEach(item => {
          if (item.device_name == device_name) {
            if (item.color == "transparent") {
              return;
            }
            has_device = true;
          }
        });
        vm.eboard_device_factory_two.forEach(item => {
          if (item.device_name == device_name) {
            if (item.color == "transparent") {
              return;
            }
            has_device = true;
          }
        });
      } else if (process == "package") {
        let this_pkg_work_code = JSON.parse(device_name).work_code;
        for (let i = 0; i < vm.eboard_package.length; i++) {
          if (
            vm.eboard_package[i]["work_code"] != undefined &&
            vm.eboard_package[i]["work_code"] != ""
          ) {
            if (vm.eboard_package[i]["work_code"] == this_pkg_work_code) {
              if (vm.eboard_package[i]["status"] == "S") {
                return;
              }
              has_device = true;
            }
          }
        }
      } else if (process == "container-load") {
        vm.eboard_container.forEach(item => {
          if (item.device_name == device_name) {
            if (item.status == "S") {
              return;
            }
            has_device = true;
          }
        });
      }

      if (!has_device) {
        return;
      }
      vm.set_previousPage("home");
      vm.set_deviceName(device_name);
      if (process == "container-load") {
        vm.set_shipmentProcess("裝櫃-即時狀態");
      }
      vm.set_sideBarSelect(["elecboard", process, group]);
      vm.clearTimer();
      vm.change_selectPage("machstatus");
      vm.change_selectPageName(vm.pageName.machstatus);
      sessionStorage.setItem("mes_machStatus_previousPageName", "home");
      vm.$router.push("/index/machstatus");
    },
    get_factory_data() {
      let vm = this;
      if (vm.selectPage != "home") {
        return;
      }

      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["processName"] = vm.sideBarSelect.processName;
      params["whichFunction"] = "MainQuery";
      vm.query_time = new Date();
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        console.log(result);
        if (result.Response == "ok") {
          let result_data = result["QueryTableData"][0];
          let all_device_data = result_data["all_device_data"];
          let err_status = result_data["err_status"];

          vm.eboard_device_factory_one.forEach((data, index) => {
            if (all_device_data[data.device_name] == undefined) {
              vm.eboard_device_factory_one[index].color = "transparent";
              vm.eboard_device_factory_one[index].message = "";
            } else {
              if (all_device_data[data.device_name]["status"] == "R") {
                vm.eboard_device_factory_one[index].color = "#00ff00";
              } else if (all_device_data[data.device_name]["status"] == "Q") {
                vm.eboard_device_factory_one[index].color = "#ffc100";
              } else if (all_device_data[data.device_name]["status"] == "H") {
                vm.eboard_device_factory_one[index].color = "#ff0000";
              } else if (all_device_data[data.device_name]["status"] == "S") {
                vm.eboard_device_factory_one[index].color = "#cccccc";
              } else if (all_device_data[data.device_name]["status"] == "M") {
                vm.eboard_device_factory_one[index].color = "#cccdfe";
              } else if (all_device_data[data.device_name]["status"] == "D") {
                vm.eboard_device_factory_one[index].color = "#09b0ff";
              } else if (all_device_data[data.device_name]["status"] == "I") {
                vm.eboard_device_factory_one[index].color = "#99f98c";
              } else {
                vm.eboard_device_factory_one[index].color = "transparent";
              }
              vm.eboard_device_factory_one[index].message =
                all_device_data[data.device_name]["message"];
            }
          });
          vm.eboard_device_factory_two.forEach((data, index) => {
            if (all_device_data[data.device_name] == undefined) {
              vm.eboard_device_factory_two[index].color = "transparent";
              vm.eboard_device_factory_two[index].message = "";
            } else {
              if (all_device_data[data.device_name]["status"] == "R") {
                vm.eboard_device_factory_two[index].color = "#00ff00";
              } else if (all_device_data[data.device_name]["status"] == "Q") {
                vm.eboard_device_factory_two[index].color = "#ffc100";
              } else if (all_device_data[data.device_name]["status"] == "H") {
                vm.eboard_device_factory_two[index].color = "#ff0000";
              } else if (all_device_data[data.device_name]["status"] == "S") {
                vm.eboard_device_factory_two[index].color = "#cccccc";
              } else if (all_device_data[data.device_name]["status"] == "M") {
                vm.eboard_device_factory_two[index].color = "#cccdfe";
              } else if (all_device_data[data.device_name]["status"] == "D") {
                vm.eboard_device_factory_two[index].color = "#09b0ff";
              } else if (all_device_data[data.device_name]["status"] == "I") {
                vm.eboard_device_factory_two[index].color = "#99f98c";
              } else {
                vm.eboard_device_factory_two[index].color = "transparent";
              }
              vm.eboard_device_factory_two[index].message =
                all_device_data[data.device_name]["message"];
            }
          });

          vm.err_status_data = err_status;
          let package_data = result_data["package_data"];
          let eboard_package = vm.eboard_package;
          eboard_package.forEach((data, index) => {
            if (data.shape == "rect") {
              if (package_data[data.device_name] == undefined) {
                vm.eboard_package[index].color = "transparent";
                vm.eboard_package[index].message = "";
              } else {
                if (package_data[data.device_name]["status"] == "R") {
                  vm.eboard_package[index].color = "#00ff00";
                } else if (package_data[data.device_name]["status"] == "Q") {
                  vm.eboard_package[index].color = "#ffc100";
                } else if (package_data[data.device_name]["status"] == "H") {
                  vm.eboard_package[index].color = "#ff0000";
                } else {
                  vm.eboard_package[index].color = "transparent";
                }
                vm.eboard_package[index].message =
                  package_data[data.device_name]["message"];
                vm.eboard_package[index].work_code =
                  package_data[data.device_name]["work_code"];
              }
            }
          });

          let container_data = result_data["container_data"];
          let eboard_container = vm.eboard_container;
          eboard_container.forEach((data, index) => {
            if (data.shape == "rect") {
              if (container_data[data.device_name] == undefined) {
                vm.eboard_container[index].color = "#cccccc";
                vm.eboard_container[index].message = "";
              } else {
                if (container_data[data.device_name]["status"] == "R") {
                  vm.eboard_container[index].color = "#00ff00";
                } else if (container_data[data.device_name]["status"] == "Q") {
                  vm.eboard_container[index].color = "#ffc100";
                } else if (container_data[data.device_name]["status"] == "H") {
                  vm.eboard_container[index].color = "#ff0000";
                } else {
                  vm.eboard_container[index].color = "#cccccc";
                }
                vm.eboard_container[index].message =
                  container_data[data.device_name]["message"];
                vm.eboard_container[index].work_code =
                  container_data[data.device_name]["sign_code"];
                vm.eboard_container[index].load_status =
                  container_data[data.device_name]["load_status"];
                vm.eboard_container[index].status =
                  container_data[data.device_name]["status"];
              }
            }
          });
        }
        vm.query_counter++;
        vm.getNowTime();
        if (vm.query_time != null) {
          vm.query_time = null;
          setTimeout(function() {
            vm.get_factory_data();
          }, 1000);
        }
      });
    },
    get_err_status(process, device_name) {
      let vm = this;
      let erro_status_item = [];
      vm.err_status_data.forEach(data => {
        if (data.process == process && data.device_name == device_name) {
          erro_status_item.push({
            process: data.process,
            device_name: data.device_name,
            machine_abn_id: data.machine_abn_id,
            machine_abn_description: data.machine_abn_description,
            machine_video: data.machine_video,
            machine_erro_time: data.machine_erro_time
          });
          vm.erro_status_item = erro_status_item;
          vm.erro_detail = true;
          return;
        }
      });
    },
    clearTimer() {
      var highestIntervalId = setInterval(";");
      for (var i = 0; i < highestIntervalId; i++) {
        //清除所有計時資料
        clearInterval(i);
      }
    },
    getNowTime() {
      let vm = this;
      let Today = new Date();
      vm.nowtime =
        Today.getFullYear() +
        "-" +
        String(Today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(Today.getDate()).padStart(2, "0") +
        " " +
        String(Today.getHours()).padStart(2, "0") +
        ":" +
        String(Today.getMinutes()).padStart(2, "0") +
        ":" +
        String(Today.getSeconds()).padStart(2, "0");
      console.log(vm.nowtime);
      // setTimeout(function () {
      //   vm.getNowTime();
      // }, 1000);
    },
    homeMapSize(size) {
      let vm = this;
      vm.home_map.clientWidth = size.width;
      vm.home_map.clientHeight = size.height;
    },
    setSessionItems() {
      sessionStorage.setItem(
        "mes_home_selected",
        this.sideBarSelect.processName
      );
    }
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.setSessionItems);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>

<style lang="scss">
.popover-body {
  font-size: 18px;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
}

.elecboard-popover.popover {
  max-width: unset;
}
.elecboard-popover > .popover-body {
  background-color: rgba(50, 50, 50, 0.7);
  color: #ffffff;
}
.elecboard-popover > .arrow::after {
  border-top-color: rgba(50, 50, 50, 0.7);
  border-bottom-color: rgba(50, 50, 50, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue